<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import {exists} from 'shared/utils/custom-utils';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let icon: UIcons | null = null;
    export let title: string | null = null;
    export let additionalClasses = '';
</script>

<IconedContent {icon}
               gap="0px"
               iconColor="var(--text-muted)"
               additionalClasses="search-toolbar-section {additionalClasses}">

    {#if exists(title)}
        <span class="title">{title}:</span>
    {/if}

    <div class="search-toolbar-section-content">
        <slot/>
    </div>
</IconedContent>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .title {
        margin-left: @spacing-s;
        margin-right: @spacing-sm;
        color: @themed-text-muted;
    }

    .search-toolbar-section-content {
        display: flex;
        align-items: center;
        height: 100%;
        gap: @spacing-sm;
        white-space: nowrap;
    }
</style>